module.exports = __webpack_public_path__ + "img/responsive crc-05.05396717.jpg";